<template>
  <section
    ref="workflowVideoRef"
    class="workflow-video"
    :style="boxStyle"
    aria-label="StoReel workflow video"
  >
    <video v-if="loaded" :src="src" autoplay muted loop playsinline preload="metadata" />
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import type { CSSProperties } from 'vue'

import type { DesignBox } from '../../data/home2026'

const props = defineProps<{
  box: DesignBox
  src: string
  scaledPx: (value: number) => string
}>()

const workflowVideoRef = ref<HTMLElement | null>(null)
const loaded = ref(false)
let workflowVideoObserver: IntersectionObserver | undefined

const boxStyle = computed<CSSProperties>(() => ({
  left: props.scaledPx(props.box.x),
  top: props.scaledPx(props.box.y),
  width: props.scaledPx(props.box.w),
  height: props.scaledPx(props.box.h),
}))

onMounted(() => {
  if ('IntersectionObserver' in window && workflowVideoRef.value) {
    workflowVideoObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return

        loaded.value = true
        workflowVideoObserver?.disconnect()
      },
      { rootMargin: '700px 0px' },
    )
    workflowVideoObserver.observe(workflowVideoRef.value)
  } else {
    loaded.value = true
  }
})

onUnmounted(() => {
  workflowVideoObserver?.disconnect()
})
</script>

<style scoped>
.workflow-video {
  position: absolute;
  z-index: 2;
  left: 50% !important;
  width: 100vw !important;
  overflow: hidden;
  border-radius: var(--video-radius);
  background: #020307;
  contain: layout paint style;
  transform: translateX(-50%);
}

.workflow-video video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
